/*****************************************************
  OBSERVER TO ADD PARALLAX EFFECT
/*****************************************************/
var scrollParallax = []
var scrolled = 0

// screen height
var v_height =
	window.innerHeight ||
	document.documentElement.clientHeight ||
	document.body.clientHeight

function doParallax(elm) {
	let boundes = elm.dataset.parallax.split(',') 

	let distance = Math.abs(boundes[0] - boundes[1])
	if (boundes[0] > boundes[1]) {
		
		distance = distance * -1
	}

	const unit_scroll = distance / (v_height + elm.offsetHeight)
	let temp = 0

	let topElement = 0
	let element = elm

	let id_elem = elm.dataset.parallaxid

	do {
		topElement += element.offsetTop || 0
		element = element.offsetParent
	} while (element)

	let parallaxFunction = function () {
		//Obtain the distance between top screen and document top 0
		scrolled = document.documentElement.scrollTop || window.pageYOffset;
		//Distance of bottom page to top of the element
		let relative_distance = scrolled + v_height - topElement;
		//transpoling data to move the parallax element relative to the scroll of all the screen
		temp = unit_scroll * relative_distance + parseInt(boundes[0]);
		elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)');
	}

	scrollParallax[id_elem] = parallaxFunction

	window.addEventListener('scroll', scrollParallax[id_elem])
}

let observers_parallax = document.querySelectorAll('.js-parallax-element')

if (observers_parallax) {
	let options_parallax = {
		root: null,
		rootMargin: '0px',
		threshold: 0,
	}

	function handler_parallax(entries, observer) {
		let entry
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				doParallax(entry.target)
			} else {
				let id_elem = entry.target.dataset.parallaxid
				window.removeEventListener('scroll', scrollParallax[id_elem])
			}
		})
	}

	let observable_parallax = new IntersectionObserver(
		handler_parallax,
		options_parallax,
	)
	let counter = 1
	observers_parallax.forEach(function (element) {
		observable_parallax.observe(element)
		element.dataset.parallaxid = counter
		counter++
	})
}
